<template>
  <div>
    <div class="footer">
      <div class="wd">
        <div>
          <h4>注：本公司在上海及其他地区无分公司</h4>
          <p>电话：010-85788727&nbsp;&nbsp;&nbsp;&nbsp;</p>
          <p>商务合作：txbusiness@tianxingshuke.com &nbsp;&nbsp;&nbsp;&nbsp;</p>
          <p>地址：北京市朝阳区常通路3号院长楹星座一栋2302</p>
          <p style="color:#888888;">Copyright © {{currentYear}} 北京天行数科数据科技有限公司&nbsp;&nbsp;版权所有 <a href="https://beian.miit.gov.cn" target="_blank">京ICP备16005607号-1 </a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    data () {
      return {
        currentYear: ''
      }
    },
    mounted: function () {
      let that = this;
      var myDate = new Date();
      that.currentYear = myDate.getFullYear();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Footer.vue